/**
 * Author: Qian.qianchen 2018-11-13
 * discription: 产品管理 微博 微博账号编辑
 */
"use strict";
angular.module("productManageMentEditBaijiahaoModule", [])
    .controller('productManageMentEditBaijiahaoCtrl', ['$scope', '$modalInstance', 'modalDialog', 'item', 'trsHttpService', '$validation', function($scope, $modalInstance, modalDialog, item, trsHttpService, $validation) {
        initStatus();

        function initStatus() {

            $scope.data = {
                currUser: {
                    baiJiaHaoAccountName: item.ACCOUNTNAME,
                    baiJiaHaoAccountId: item.BAIJIAHAOACCOUNTID,
                    appName: item.ACCOUNTNAME,
                    appId: item.APPID,
                    appToken: item.APPTOKEN,
                    serviceId: 'mlf_baijiahaoconfig',
                    methodName: "editBaiJiaHaoAccount",
                }
            }
        }
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', $scope.data.currUser, 'post', true).then(function(data) {
                $modalInstance.close({result: true});
            }, function(data) {
                $modalInstance.close({result: false, data:data});
            });
        };
    }]);